import * as React from 'react'
import {useCallback, useMemo} from 'react'

import type {BuildType} from '../../../../services/rest'
import type {ProjectId} from '../../../../types'
import NestedSubprojectsAndBuildTypes from '../../../common/NestedSubprojectsAndBuildTypes/NestedSubprojectsAndBuildTypes'
import {ContentContext} from '../../../common/NestedSubprojectsAndBuildTypes/NestedSubprojectsAndBuildTypesContext'
import {
  ResetLoadingStateProvider,
  useSequenceLoaderReadyHandler,
} from '../../../common/SequenceLoader/SequenceLoader.hooks'

import BuildTypeProblemList from './BuildTypeProblemList/BuildTypeProblemList'

type OwnProps = {
  projectId: ProjectId
  onlyFavorites?: boolean
  projectsReady: boolean
  level?: number
  buildTypes?: BuildType[]
}

const NestedBuildTypeProblems = ({
  projectId,
  onlyFavorites = false,
  projectsReady,
  level = 0,
  buildTypes,
}: OwnProps) => {
  useSequenceLoaderReadyHandler(false)

  const nestedBuildTypeRender = useCallback(
    (nestedProjectId: ProjectId) => (
      <BuildTypeProblemList projectId={nestedProjectId} buildTypes={buildTypes} />
    ),
    [buildTypes],
  )

  return useMemo(
    () => (
      <ResetLoadingStateProvider>
        <ContentContext.Provider value={nestedBuildTypeRender}>
          <NestedSubprojectsAndBuildTypes
            projectId={projectId}
            onlyFavorites={onlyFavorites}
            projectsReady={projectsReady}
            hasSubprojectContent
            level={level}
          />
        </ContentContext.Provider>
      </ResetLoadingStateProvider>
    ),
    [level, nestedBuildTypeRender, onlyFavorites, projectId, projectsReady],
  )
}

export default NestedBuildTypeProblems
